import { createAsyncThunk } from "@reduxjs/toolkit";
import { postData } from "../../apiservice/apis";
import {
  getAccountBySeachApi,
  getCustomersApi,
  getEmployeesApi,
  getLocationApi,
  getUserApi,
  getTagGroupNameApi,
  getTagFieldApiofgroupid,
  getBranchApi,
  getWarehouseApi,
  getAccountByTypeApi,
  singleInstitutionDetailApi,
  getUserRoleSubscriptionWiseListApi,
} from "../../apiservice/setting";

import { getSuppliersApi } from "../../apiservice/purchase";

import {
  getItemBySearchApi,
  getItemCategoriesApi,
  getItemGroupsApi,
  getItemApi,
  getBatchAvailabilityApi,
  getSundryDebitorBalanceApi,
  getGenericNamesApi,
} from "../../apiservice/accounts";

import {
  getItemModelsApi,
  getItemOriginsApi,
  getItemUnitApi,
  getItemRackApi,
} from "../../apiservice/inventory";
import { getTagOnEdit } from "../../services/accounts";
import { getCurrentEmployeeApi } from "../../apiservice/hrpayroll";


export const fetchSingleInstitutionDetails = createAsyncThunk(
  "lookups/fetchSingleInstitutionDetails",
  async (_, { getState, rejectWithValue }) => {
    const state = getState();
    const authInfo = state.auth.auth_info;
    try {
      const res = await singleInstitutionDetailApi({ id: authInfo.id });
      return res?.data?.data?.[0];
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchEmployees = createAsyncThunk(
  "lookups/fetchEmployees",
  async (payload = {}, { rejectWithValue }) => {
    try {
      const res = await getEmployeesApi({notIncludeTerminated:payload.notIncludeTerminated});
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchCurrentEmployee = createAsyncThunk(
  "lookups/fetchCurrentEmployees",
  async (employee_id, { rejectWithValue }) => {
    try {   
      if(!employee_id) return;
      const res = await getCurrentEmployeeApi(employee_id);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchGenericNames =
  createAsyncThunk(
    "lookups/fetchGenericNames",

    async (_, { rejectWithValue }) => {

      try {

        const response =
          await getGenericNamesApi();

        return response.data;

      } catch (error) {

        return rejectWithValue(
          error.response?.data ||
          error.message
        );
      }
    }
  );

export const fetchCustomers = createAsyncThunk(
  "lookups/fetchCustomers",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getCustomersApi(null);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchSuppliers = createAsyncThunk(
  "lookups/fetchSuppliers",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getSuppliersApi(null);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchItems = createAsyncThunk(
  "lookups/fetchItems",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getItemApi(null);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchBatchAvailability = createAsyncThunk(
  "purchaseEntry/fetchBatchAvailability",
  async ({ item_id, qty = null}, { rejectWithValue }) => {
    try {
      const res = await getBatchAvailabilityApi({ item_id, qty });
      return { item_id, batches: res.data || [] };
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchPreviousDue = createAsyncThunk(
  "pos/fetchPreviousDue",
  async (customerId, { rejectWithValue }) => {
    try {
      const res = await getSundryDebitorBalanceApi({ customerId });
      if (!res.data.accounts || res.data.accounts.length === 0) {
        return 0;
      }
      return res.data.accounts[0].balance;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchTaxAccs = createAsyncThunk(
  "lookups/fetchTaxAccs",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getAccountByTypeApi({ acc_type_id: "dutie_&_tax" });
      return res.data?.length > 0 ? res.data : null;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);
export const fetchCurrentAssetAccs = createAsyncThunk(
  "lookups/fetchCurrentAssetAccs",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getAccountByTypeApi({ acc_type_id: "current_assets" });
      return res.data?.length > 0 ? res.data : null;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

export const fetchFixedAssetAccs = createAsyncThunk(
  "lookups/fetchFixedAssetAccs",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getAccountByTypeApi({ acc_type_id: "fixed_asset" });
      return res.data?.length > 0 ? res.data : [];
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

export const fetchDiscountAccs = createAsyncThunk(
  "lookups/fetchDiscountAccs",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getAccountByTypeApi({
        acc_type_id: "direct_income",
        acc_name: "discount on purchase",
      });
      return res.data?.length > 0 ? res.data : null;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

export const fetchSalaryAccs = createAsyncThunk(
  "lookups/fetchSalaryAccs",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getAccountByTypeApi({ acc_name: "salary" });
      return res.data?.length > 0 ? res.data : null;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

export const fetchLoadIntoAccs = createAsyncThunk(
  "lookups/fetchLoadIntoAccs",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getAccountBySeachApi({
        multiType: ["cash_in_hand", "bank_account", "cheque"],
      });
      return res.data?.length > 0 ? res.data : null;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

export const fetchLoadIntoAccsExcludeCheque = createAsyncThunk(
  "lookups/fetchLoadIntoAccsExcludeCheque",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getAccountBySeachApi({
        multiType: ["cash_in_hand", "bank_account", ],
      });
      return res.data?.length > 0 ? res.data : null;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

export const fetchAccountsByType = createAsyncThunk(
  "lookups/fetchAccountsByType",
  async (types, { rejectWithValue }) => {
    try {
      const res = await getAccountBySeachApi({
        multiType: types,
      });
      return res.data?.length > 0 ? res.data : null;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || err.message);
    }
  }
);

// export const fetchCustomers = createAsyncThunk(
//   "salesRecord/fetchCustomers",
//   async (_, { rejectWithValue }) => {
//     try {
//       const res = await getAccountBySeachApi({
//       query: customer_name.trim(),
//       type: "debitor",
//       acc_type_name: data,
//     });
//       return res.data;
//     } catch (err) {
//       return rejectWithValue(err.response?.data || err.message);
//     }
//   }
// );

export const fetchCustomersBySearch = createAsyncThunk(
  "salesRecord/fetchCustomersBySearch",
  async (search, { getState }) => {
    const state = getState();
    const authInfo = state.auth.auth_info;
    let data = [];
    if (authInfo.subscription === "SuperERP") {
      data = ["Customer", "Patient"];
    } else if (authInfo.branch_company_type === "Pharmacy") {
      data = ["Customer", "Patient"];
    } else {
      data = ["Customer"];
    }
    const res = await getAccountBySeachApi({ query: search, type: "debitor" });
    return res.data || [];
  }
);

export const fetchItemsBySearch = createAsyncThunk(
  "lookups/fetchItemsBySearch",
  async (search, { rejectWithValue }) => {
    try {
      const res = await getItemBySearchApi({ query: search.trim() });
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchTagGroups = createAsyncThunk(
  "lookups/fetchTagGroups",
  async (_, { getState, rejectWithValue }) => {
    const state = getState();
    const authInfo = state.auth.auth_info;
    const payload = {
      branch_id: authInfo.userInfo.branch_id,
      institution_id: authInfo.userInfo.pro_id,
    };
    try {
      const res = await getTagGroupNameApi(payload);
      return res.data.data.map((item) => ({
        id: item.id,
        tag_groupname: item.group_name,
      }));
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchTagGroupFields = createAsyncThunk(
  "salesRecord/fetchTagGroupFields",
  async (groupId, { rejectWithValue }) => {
    try {
      let res;
      if (groupId) {
        res = await getTagFieldApiofgroupid({ tag_groupnameid: groupId });
      } else {
        res = await getTagFieldApiofgroupid();
      }

      let data = res?.data?.data.map((item) => ({
        id: item.id,
        display_text: `${item.group_name}/${item.field_name}`,
        raw: item,
      }));

      return data || [];
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);


// on edit of entries fetch saved tag
export const fetchTagsOnEdit = createAsyncThunk(
  "lookups/fetchTagsOnEdit",
  async ({ tab_id, type }, { rejectWithValue }) => {
    try {
      const res = await getTagOnEdit({ tab_id, type });

      const data = res?.data?.data || [];

      const formatted = data.map(item => ({
        id: item.tag_field_id,
        display_text: `${item.group_name}/${item.display_text}`,
      }));

      return formatted;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);


export const fetchGroups = createAsyncThunk(
  "lookups/fetchGroups",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getItemGroupsApi(null);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchCategories = createAsyncThunk(
  "lookups/fetchCategories",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getItemCategoriesApi(null);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchUsers = createAsyncThunk(
  "lookups/fetchUsers",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getUserApi({ "select-type": "active" });
      return res.data.message;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchUserRoles = createAsyncThunk(
  "lookups/fetchUserRoles",
  async (_, { getState, rejectWithValue }) => {
    const state = getState();
    const authInfo = state.auth.auth_info;
    try {
      const res = await getUserRoleSubscriptionWiseListApi({
        id: authInfo.subscription_id,
        institution_id: authInfo.id,
      })
      let subscriptionbasedata = res.data.subscriptionBaseData;
      let userAddedRoles = res.data.userAddedRoles;
      const mergedRoles = [
        ...subscriptionbasedata,
        ...userAddedRoles.map((role) => ({
          ...role,
        })),
      ];
      let data = mergedRoles.filter(item => !item.role_name?.toLowerCase().endsWith('_customer')).map((item) => ({
        value: item.id,
        display: item.role_name,
        label: item.role_name.includes("_")
          ? item.role_name.split("_").slice(2).join(" ")
          : item.role_name,
      }));

      return data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);


export const fetchWarehouse = createAsyncThunk(
  "lookups/fetchWarehouse",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getWarehouseApi({ "select-type": "active" });
      return res.data.message;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const fetchLocations = createAsyncThunk(
  "lookups/locations",
  async () => {
    const res = await getLocationApi(null);
    return res.data;
  }
);
export const fetchOrigins = createAsyncThunk("lookups/origins", async () => {
  const res = await getItemOriginsApi(null);
  return res.data;
});
export const fetchItemModels = createAsyncThunk(
  "lookups/itemModels",
  async () => {
    const res = await getItemModelsApi(null);
    return res.data;
  }
);
export const fetchItemRack = createAsyncThunk("lookups/itemRacks", async () => {
  const res = await getItemRackApi(null);
  return res.data;
});
export const fetchItemUnit = createAsyncThunk("lookups/itemUnit", async () => {
  const res = await getItemUnitApi(null);
  return res.data;
});

export const fetchBranchList = createAsyncThunk("lookups/branch", async () => {
  const res = await getBranchApi({ "select-type": "active" });
  return res?.data?.message;
});





// export const fetchItemSerials = createAsyncThunk("lookups/itemSerials", async (query) => {
//   const res = await api.get("/item-serials", { params: { search: query } });
//   return res.data;
// });
